import { TrashRestoreResult } from 'api/media';

export const MediaLibraryPageConfig = {
  PAGE_SIZE: 40,
  TRASH_PAGE_SIZE: 20,
  SEARCH_DEBOUNCE_MS: 250,
  SHIFT_HINT_INTERVAL_MS: 10 * 1000,
  ALBUM_DELETE_MAX_SUB_ALBUM_NAMES: 5,
  ALBUM_NAME_MAX_LENGTH: 120,
  ASSET_NAME_MAX_LENGTH: 255,
  UNDO_TOAST_DURATION_MS: 8 * 1000,
  SHARED_ALBUMS_SCOPE: 'shared' as const,
};

export const RESTORED_MESSAGE_KEYS: Record<
  TrashRestoreResult['placed'],
  string
> = {
  original: 'mediaLibrary.page.trash.restored',
  top_level: 'mediaLibrary.page.trash.restoredTopLevel',
  main_album: 'mediaLibrary.page.trash.restoredMainAlbum',
};

export const MediaLibraryDndType = {
  Assets: 'mediaLibraryPage/assets',
  Album: 'mediaLibraryPage/album',
} as const;

export const MEDIA_LIBRARY_DND_TYPES: string[] =
  Object.values(MediaLibraryDndType);
